import React, {useContext, useEffect} from 'react';
import {Link, NavLink} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import {Button, Box, Grid, Typography, Container} from '@material-ui/core';
import {Anchor, Document} from 'components/icons/icons';
import {AppCtx} from 'context/AppContext';
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';
import useBrowserTitle from 'hooks/useBrowserTitle';
import {useFlags} from 'hooks';
import {useGetBin} from 'hooks/useGetEndpoint';
import {FormNames} from '../constants';
import {P} from './TypographyShortcuts';

const useStyles = makeStyles(theme => ({
    button: {
        backgroundColor: theme.palette.primary.light2,
        border: 0,
        borderRadius: 3,
        height: 70,
        width: 70,
        margin: '2px 30px',
        padding: '10px',
    },
}));

const AddDocs = () => {
    useBrowserTitle(`| Add Document`);
    const classes = useStyles();
    const {setInForm} = useContext(AppCtx);
    const {supporting_form_active} = useFlags();
    const {data: last} = useGetBin();
    const {setSnackProps, setSnackOpen, setFormRedirect} = useContext(AppCtx);

    // This is pre-form so set form context
    useEffect(() => {
        setInForm(true);
        return () => {
            setInForm(false);
        };
    }, [setInForm]);

    useEffect(() => {
        if (last?.url?.match(new RegExp('/forms/'))) {
            const formType = last.url.split('/')[2];
            const formName =
                FormNames[formType?.toUpperCase()] || formType?.toUpperCase();
            setSnackOpen(true);
            setSnackProps({
                severity: 'info',
                message: (
                    <P>
                        Looks like you were last working on a {formName} form.
                        Click{' '}
                        <Link
                            to={last?.url}
                            onClick={() => setFormRedirect(true)}
                        >
                            here
                        </Link>{' '}
                        to resume progress.
                    </P>
                ),
            });
        }
        //eslint-disable-next-line
    }, [last]);

    return (
        <Container maxWidth='sm'>
            <Box textAlign='center'>
                <Grid
                    container
                    spacing={2}
                    direction='column'
                    justifyContent='flex-start'
                    alignItems='center'
                >
                    <Grid item />
                    <Grid item>
                        <Typography variant='h6'>
                            Select the type of document you are adding.
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            className={classes.button}
                            component={NavLink}
                            to='/addseaservice'
                        >
                            <Anchor height={50} width={50} />
                        </Button>
                        <Typography>Sea Service</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            className={classes.button}
                            component={NavLink}
                            to='/addtraining'
                        >
                            <Document height={50} width={50} />
                        </Button>
                        <Typography>Training</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            className={classes.button}
                            component={NavLink}
                            to='/forms/supporting'
                            disabled={!supporting_form_active}
                        >
                            <FolderOutlinedIcon fontSize='large' />
                        </Button>
                        <Typography>Documents</Typography>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default AddDocs;
